import { useEffect, useState } from "react";
import { ARROW_UR } from "./Bits";
import { RESUME_URL } from "../data";

function torontoTime(): string {
  try {
    const t = new Intl.DateTimeFormat("en-GB", {
      timeZone: "America/Toronto",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }).format(new Date());
    return "TOR " + t;
  } catch {
    return "";
  }
}

export function Header() {
  const [clock, setClock] = useState(torontoTime);

  useEffect(() => {
    const id = setInterval(() => setClock(torontoTime()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <header>
      <a className="mk" href="#home">
        NEHAN PUNJANI
      </a>
      <nav>
        <a className="nlink" href="#about">
          About
        </a>
        <a className="nlink" href="#expertise">
          Expertise
        </a>
        <a className="nlink" href="#career">
          Career
        </a>
        <a className="nlink" href="#work">
          Work
        </a>
        <a className="nlink" href="#contact">
          Contact
        </a>
        <a className="res" href={RESUME_URL} target="_blank" rel="noreferrer">
          Résumé <span>{ARROW_UR}</span>
        </a>
      </nav>
      <span className="clock">{clock}</span>
    </header>
  );
}
